// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function DateIcon$FromPlainDate(props) {
  var date = props.date;
  var day = date.toLocaleString("en-us", {
        day: "numeric"
      });
  var month = date.toLocaleString("en-us", {
        month: "short"
      });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: month,
                      className: "text-white rounded-t-md font-semibold uppercase text-sm bg-tan-blue-500 text-center py-0.5"
                    }),
                JsxRuntime.jsx("div", {
                      children: day,
                      className: "text-center text-2xl text-gray-800 py-0.5 px-0.5"
                    })
              ],
              className: "rounded-md shadow-md flex flex-col w-12"
            });
}

var FromPlainDate = {
  make: DateIcon$FromPlainDate
};

exports.FromPlainDate = FromPlainDate;
/* react/jsx-runtime Not a pure module */
